export const reviewSummary = {
  rating: "4.9",
  label: "Excelente",
  count: "más de 900",
};

export const reviews = [
  {
    name: "Mariana R.",
    meta: "47 años · México",
    when: "Hace 2 días",
    title: "Por fin entendí qué me pasaba de noche",
    text: "Cenaba ensalada todas las noches y me levantaba hinchada. Con las cenas calientes del recetario, a la semana ya me despertaba mucho más liviana.",
  },
  {
    name: "Claudia P.",
    meta: "52 años · España",
    when: "Hace 5 días",
    title: "Simple y rápido de verdad",
    text: "Llego agotada del trabajo y no tengo ganas de cocinar. Las recetas de 15 minutos me salvaron. El planificador me sacó la pregunta de “¿qué ceno hoy?”.",
  },
  {
    name: "Verónica L.",
    meta: "41 años · Argentina",
    when: "Hace 1 semana",
    title: "Duermo mejor y sin ansiedad por dulce",
    text: "El ritual de cierre y las infusiones me cambiaron las noches. Ya no termino comiendo chocolate después de cenar.",
  },
  {
    name: "Patricia G.",
    meta: "45 años · Colombia",
    when: "Hace 2 semanas",
    title: "Vale cada centavo",
    text: "Probé probióticos, ayuno y dejar harinas. Lo que me faltaba era ordenar la cena. Material claro, lindo y muy práctico.",
  },
];
